import type { CreatePharmacyLinkDto, CreatePharmacyLinkResponse, InitiatePharmacyLinkDto, InitiatePharmacyLinkResponse, PharmacyLinkDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { ListResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PharmacyLinkService {
  apiName = 'Default';
  

  create = (input: CreatePharmacyLinkDto, cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CreatePharmacyLinkResponse>({
      method: 'POST',
      url: '/api/app/pharmacy-link',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/pharmacy-link/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getList = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, ListResultDto<PharmacyLinkDto>>({
      method: 'GET',
      url: '/api/app/pharmacy-link',
    },
    { apiName: this.apiName,...config });
  

  initiate = (input: InitiatePharmacyLinkDto, cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InitiatePharmacyLinkResponse>({
      method: 'POST',
      url: '/api/app/pharmacy-link/initiate',
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
